import * as React from "react"
import { Box, Grid, Skeleton, Typography } from "@mui/material"
import { CardSeeker, CircularPercentageSeeker } from "@ui-seeker/core"
import { isEmpty } from "@ui-seeker/utils"

import { skuDetailsScores, skuDetailsScoresInLoading } from "../@signals"
import { isLoadingCommonFilters } from "@signals"


export default function SkuDetailsScores() {

    const scoreOrder = ["Stock", "Assortment", "Pricing", "PP Kpis", "Sentiment", "Keywords"]

    if (skuDetailsScoresInLoading.value.length > 0 && isLoadingCommonFilters.value) return <Skeleton height={300} />
    if (isEmpty(skuDetailsScores.value)) return <></>

    return <CardSeeker title={'Global Score'} sx={{ height: '100%'}}>
        <Box sx={{ padding: 1 }}>
            <Grid container spacing={2}>
                {scoreOrder.map((label, index) => (
                        skuDetailsScores.value[label] !== undefined && <Grid item xs={4} key={index}>
                            <SkuDetailsScoresCircleSummary 
                                component={label} 
                                score={skuDetailsScores.value[label]} 
                            />
                        </Grid>
                        )
                    )}
            </Grid>
        </Box>
    </CardSeeker>
}


const SkuDetailsScoresCircleSummary = ({ component, score }) => {
	return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
		{component && <Typography variant="subtitle1" className="label" sx={{ display: "inline", fontSize: 12 }}>
			{component}
		</Typography>}
		<CircularPercentageSeeker
			value={score}
			// onClick={onClick}
			pattern={[
				{ value: 89, color: "success.main" },
				{ value: 79, color: "success.light" },
				{ value: 49, color: "warning.main" },
				{ value: "else", color: "error.main" }
			]}
		/>
	</Box>
}